"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generate_random_id = generate_random_id;
/*
 * Description: Function to create a random string,
 * useful for example for when we need to create
 * html ids or react key
 */
function generate_random_id() {
  return "dms_" + Math.random().toString(36).replace(/[^a-z]+/g, '');
}